export default __webpack_public_path__ + "static/media/estate_guide_1.92cbcf32.webp";